import { authFetch } from "../../HttpClient";

// Appels à l'API S.I (backend-myalfa : routes/siRoutes.js, module Admin
// requis). En cas d'erreur, lève une Error portant le message du serveur
// (err.message), son statut (err.status) et le corps de la réponse
// (err.data — ex. la section à jour sur un conflit 409).

const BASE = "https://backend-myalfa.vercel.app/api/si";

async function appel(chemin, { methode = "GET", corps } = {}) {
  const res = await authFetch(`${BASE}${chemin}`, {
    method: methode,
    headers: corps !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: corps !== undefined ? JSON.stringify(corps) : undefined,
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error(data?.message || "Le serveur n'a pas pu traiter la demande. Réessayez.");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

const enc = encodeURIComponent;

export const siApi = {
  // Onglet Utilisateurs
  utilisateurs: () => appel("/utilisateurs"),
  historique: (ref) => appel(`/utilisateurs/${enc(ref)}/historique`),
  creerExterne: (corps) => appel("/utilisateurs", { methode: "POST", corps }),
  modifier: (ref, corps) => appel(`/utilisateurs/${enc(ref)}`, { methode: "PATCH", corps }),
  // action : valider-arrivee | declarer-sortie | annuler-sortie | cloturer-sortie | reactiver
  transition: (ref, action, corps = {}) => appel(`/utilisateurs/${enc(ref)}/${action}`, { methode: "POST", corps }),
  supprimerExterne: (ref) => appel(`/utilisateurs/${enc(ref)}`, { methode: "DELETE" }),

  // Référentiel : sites, services, applications
  referentiel: () => appel("/referentiel"),
  remplacerListe: (categorie, libelles) => appel(`/listes/${categorie}`, { methode: "PUT", corps: { libelles } }),
  modifierApplication: (cle, corps) => appel(`/applications/${enc(cle)}`, { methode: "PATCH", corps }),
  ordonnerApplications: (cles) => appel("/applications/ordre", { methode: "PUT", corps: { cles } }),

  // Onglet Système
  sections: () => appel("/sections"),
  creerSection: (type) => appel("/sections", { methode: "POST", corps: { type } }),
  modifierSection: (cle, corps) => appel(`/sections/${enc(cle)}`, { methode: "PATCH", corps }),
  ordonnerSections: (cles) => appel("/sections/ordre", { methode: "PUT", corps: { cles } }),
  supprimerSection: (cle) => appel(`/sections/${enc(cle)}`, { methode: "DELETE" }),
  restaurerSection: (cle) => appel(`/sections/${enc(cle)}/restaurer`, { methode: "POST" }),
  sauvegardes: () => appel("/sauvegardes"),
  releverSauvegardes: () => appel("/sauvegardes/releve", { methode: "POST" }),
  lireSecret: (cle, champ) => appel(`/sections/${enc(cle)}/secrets/${enc(champ)}`),

  // Notes et commentaires — cible : "application" (ref = clé) ou "vm" (ref = _id de la ligne)
  resumeAnnotations: (cible) => appel(`/annotations/${enc(cible)}`),
  annotations: (cible, ref) => appel(`/annotations/${enc(cible)}/${enc(ref)}`),
  enregistrerNote: (cible, ref, texte) => appel(`/annotations/${enc(cible)}/${enc(ref)}/note`, { methode: "PUT", corps: { texte } }),
  ajouterCommentaire: (cible, ref, texte) => appel(`/annotations/${enc(cible)}/${enc(ref)}/commentaires`, { methode: "POST", corps: { texte } }),
  modifierCommentaire: (id, texte) => appel(`/commentaires/${enc(id)}`, { methode: "PATCH", corps: { texte } }),
  supprimerCommentaire: (id) => appel(`/commentaires/${enc(id)}`, { methode: "DELETE" }),
};
